import React from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Core components
import Card from 'components/core/Card';
// Custom
import InformationItem from 'components/items/InformationItem';
import {
  profileDataShape,
  companyDataShape,
  userPermissionsDataShape,
} from 'constants/PropTypesShapes';
import { DeleteIconButton } from 'components/buttons/IconButtons';

const CompanyItem = ({ companyId, companyList }) => {
  const company = _find(companyList, ['id', companyId]);
  if (company) {
    return <InformationItem light icon="company" value={company.name} />;
  }
  return null;
};

CompanyItem.propTypes = {
  companyList: PropTypes.arrayOf(userPermissionsDataShape),
  companyId: PropTypes.number,
};

CompanyItem.defaultProps = {
  companyId: null,
  companyList: [],
};

const ProfileItem = ({ profileList, profileId }) => {
  const profile = _find(profileList, ['id', profileId]);
  if (profile) {
    return <InformationItem light icon="profile" value={profile.name} />;
  }
  return null;
};

ProfileItem.propTypes = {
  profileId: PropTypes.number.isRequired,
  profileList: PropTypes.arrayOf(profileDataShape),
};

ProfileItem.defaultProps = {
  profileList: [],
};

const UserPermissions = ({
  permissions,
  companyList,
  profileList,
  onDeletePermission,
}) => (
  <div className="row">
    {_map(permissions, (value, index) => (
      <div key={index} className="col-6">
        <Card defaultBackground>
          {/* ----- COMPANY -----  */}
          <CompanyItem
            companyList={companyList}
            companyId={value.company_id}
          />
          {/* ----- PROFILE -----  */}
          <ProfileItem
            profileList={profileList}
            profileId={value.profile_id}
          />
          {/* ----- DELETE BUTTON -----  */}
          {onDeletePermission && (
          <div style={{ position: 'absolute', top: 16, right: 16 }}>
            <DeleteIconButton onClick={() => onDeletePermission(value)} />
          </div>
          )}
        </Card>
        {index < _size(permissions) - 1 && <div className="pt-3" />}
      </div>
    ))}
  </div>
);

UserPermissions.propTypes = {
  companyList: PropTypes.arrayOf(companyDataShape),
  permissions: PropTypes.arrayOf(
    PropTypes.shape({
      company_id: PropTypes.number,
      profile_id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  profileList: PropTypes.arrayOf(profileDataShape),
  onDeletePermission: PropTypes.func,
};

UserPermissions.defaultProps = {
  companyList: [],
  profileList: [],
  onDeletePermission: null,
};

const mapStateToProps = (state) => ({
  companyList: _get(state.company.list, 'flattenElements'),
  profileList: _get(state.profile.list.elements, 'data'),
});

module.exports = connect(mapStateToProps)(UserPermissions);



// WEBPACK FOOTER //
// ./routes/app/routes/users/assets/main/UserPermissions.js